module.exports = __webpack_public_path__ + "img/avatvr.13809cc9.png";